import { render, staticRenderFns } from "./TrialProvider.vue?vue&type=template&id=68bf5460&scoped=true&"
import script from "./TrialProvider.vue?vue&type=script&lang=js&"
export * from "./TrialProvider.vue?vue&type=script&lang=js&"
import style0 from "./TrialProvider.vue?vue&type=style&index=0&id=68bf5460&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bf5460",
  null
  
)

export default component.exports